import styled from 'styled-components';

import { mediaWideNavless } from '@xing-com/layout-tokens';
import { ProfileImageResponsive } from '@xing-com/profile-image';
import { scale020, spaceL, spaceM, spaceXL, spaceXS } from '@xing-com/tokens';
import { BodyCopy, Headline } from '@xing-com/typography';

const ProfileCardContainer = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: ${spaceXS} ${spaceXS} ${spaceM};
  position: relative;

  @media ${mediaWideNavless} {
    padding: ${spaceM} ${spaceM} ${spaceXL};
  }
`;

const ProfileCardDismissButton = styled.div`
  position: absolute;
  right: ${scale020};
  z-index: 1;
`;

const ProfileCardImageContainer = styled.div`
  text-align: center;
`;

const ProfileCardImage = styled(ProfileImageResponsive)`
  margin-bottom: ${spaceM};

  @media ${mediaWideNavless} {
    margin-bottom: ${spaceL};
  }
`;

const ProfileCardFlagContainer = styled.div`
  margin-bottom: ${spaceXS};
`;

const ProfileCardHeadline = styled(Headline)`
  margin-bottom: ${spaceM};
`;

type ProfileClampedCopyProps = {
  numberOfLines: number;
  noMargin?: boolean;
};

const ProfileClampedCopy = styled(BodyCopy)<ProfileClampedCopyProps>`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  line-clamp: 2;
  overflow: hidden;

  /* display 2 lines only */
  ${(props) => `
    -webkit-line-clamp: ${props.numberOfLines};
    line-clamp: ${props.numberOfLines};
  `}
`;

const ProfileCardInfoCopy = styled(BodyCopy)`
  margin-bottom: ${spaceL};
`;

const ProfileCardCTAContainer = styled.div`
  align-items: start;
  margin-top: auto;
`;

export const Styled = {
  ProfileCardImageContainer,
  ProfileCardDismissButton,
  ProfileCardContainer,
  ProfileCardImage,
  ProfileCardFlagContainer,
  ProfileCardHeadline,
  ProfileClampedCopy,
  ProfileCardInfoCopy,
  ProfileCardCTAContainer,
};
